export { ErrorBoundary } from "./ErrorBoundary";
export { LegacyBoundary } from "./LegacyBoundary";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@appsignal/react/dist/esm/index.js
// module id = 1248
// module chunks = 0